<template>
  <div class="download page-wrap">
    <div class="ellipse-right"></div>
    <loading-page v-show="loading"/>
    <mask-layer v-show="isShowMask" @maskClick="maskClick"/>
    <!-- <img src="./assets/img/bg2.png" class="background"> -->
    <div class="wrap">
      <div class="content">
        <div class="message">
          <img src="~@/assets/img/logo.png" class="logo">
          <img src="~@/assets/img/title.png" class="title">
          <span class="version">{{$t('version')}}</span>
        </div>
        <div class="btnDownload">
          <div class="ios" @click="download('iOS')">
            <img class="icon" :src="IconIOS" />
            <span class="text">{{ $t('btn.ios') }}</span>
          </div>
          <div class="android" @click="download('android')">
            <img class="icon" :src="IconAndroid" />
            <span class="text">{{ $t('btn.android') }}</span>
          </div>
          <div class="huawei" @click="download('huawei')">
            <img class="icon" :src="IconHuawei" />
            <span class="text">{{ $t('btn.huawei') }}</span>
          </div>
        </div>

        <!-- 华为下载说明 -->
        <div
          class="huawei-tips"
          @click="goToHuaweiDownloadExplanation"
        >
          {{ $t('huaweiDownloadTips') }}
        </div>

        <div class="qrcode">
          <div class="qrcode-wrap">
            <div ref="qrcode"></div>
          </div>
          <p class="tips">{{$t('tips')}}</p>
        </div>
      </div>
      <div class="ai-qr">
        <img src="~@/assets/img/mark-group.png" class="mark-group">
      </div>
    </div>
    <div class="mask"></div>
    <div class="ellipse"></div>
    <div class="copyRight">
      <!-- {{$t('copyRight')}} -->
      <!-- <br> -->
      &copy;
      {{$t('auth')}}
    </div>
    <div class="ellipse-left"></div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import axios from 'axios';
import LoadingPage from '@/components/LoadingPage.vue';
import MaskLayer from '@/components/MaskLayer.vue';
import IconAndroid from '@/assets/img/android.png';
import IconIOS from '@/assets/img/ios.png';
import IconHuawei from '@/assets/img/huawei.png';

import RN from '@/config/router';


export default {
  components: {
    LoadingPage,
    MaskLayer,
  },

  data() {
    return {
      model: {},
      loading: true,
      isShowMask: false, // 是否显示蒙层
      qrcodeConfig: {
        height: 110,
        width: 110,
        colorDark: '#365AA4', // 二維碼顏色
        colorLight: '#ffffff', // 二維碼背景色
      },
      IconAndroid,
      IconIOS,
      IconHuawei,
      href: '',
    };
  },

  mounted() {
    // const { locale } = this.$i18n;
    const code = process.env.CODE;
    const api = process.env.API;
    // 随机数
    const randomNum = new Date().getTime();
    const url = `${api}?code=${code}&num=${randomNum}`;
    // 请求版本数据
    axios.get(url).then(res => {
      this.loading = false;
      const data = res.data;
      this.model = {
        android: `${data.downloadUrlAndroid}`,
        iOS: `${data.downloadUrlIos}`,
      };
    }).catch(err => {
      console.log(err);
    });

    // 本地测试
    this.qrcode();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },

  methods: {
    download(type) {
      if (type === 'huawei') {
        this.href = process.env.HUAWEI_DOWNLOAD_URL;
      } else {
        this.href = this.model[type]; // 获取到下载包的地址
      }
      const userAgent = navigator.userAgent.toLowerCase(); // 判断登录端是pc还是手机
      const isWeChat = userAgent.indexOf('micromessenger') !== -1; // 通过userAgent是否包含MicroMessenger来判断是否在微信内置浏览器打开网页
      const isQQ = userAgent.indexOf('qq/') !== -1;
      const isAndroid = userAgent.indexOf('android') !== -1;
      const isIphone = userAgent.indexOf('iphone os') !== -1;

      if (isAndroid && isWeChat) {
        this.isShowMask = true;
        return;
      } if (isIphone && (isWeChat || isQQ)) {
        this.isShowMask = true;
        return;
      }

      if (this.href) {
        location.href = this.href; // 当前页面打开url页面
      }
    },

    maskClick() {
      this.isShowMask = false;
    },
    async qrcode() {
      const dom = this.$refs.qrcode;
      const link = process.env.DOWNLOAD_LINK || location.href;
      const option = Object.assign({}, this.qrcodeConfig, {
        text: link,
      });
      // eslint-disable-next-line no-new
      new QRCode(dom, option); // 生成二维码
    },

    goToHuaweiDownloadExplanation() {
      this.$router.push({ name: RN.HuaweiDownloadExplanation });
    },
  },
};
</script>


<style lang='less' scoped>
@theme-color: #365AA4;

.download{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;

  .wrap {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    order: 1;
    padding-left: 22px;
    padding-right: 22px;

    .content {
      padding-top: 12%;
      .message {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 8%;
        .logo {
          width: 64px;
          height: 64px;
        }
        .title {
          margin: 16px 0px 12px 0px;
          width: 96px;
        }
        .version {
          color: #444;
          font-size: 16px;
          font-weight: 300;
          text-align: center;
        }
      }
      .btnDownload {
          width: 100%;
          margin-top: 8%;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          & > div {
            display: flex;
            align-items: center;
            flex-direction: column;
            color: #000;
            border-radius: 12px;
            font-size: 15px;
            padding: 15px 0;
            cursor: pointer;
            background-color: #fff;
            height: 88px;
            pointer-events: inherit;
            & > .text {
              padding-top: 6px;
              font-size: 15px;
            }
            & > .icon {
              width: 36px;
              height: 36px;
            }
          }
      }


      .huawei-tips {
        width: fit-content;
        margin-top: 15px;
        color: #0868C3;
        font-size: 13px;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        cursor: pointer;
      }

      @media screen and (max-width: 200px) {
        .btnDownload {
          grid-template-columns: 1fr;
        }
      }
      .qrcode {
        display: none;
      }
    }
    .ai-qr{
      width: 100%;
      position: relative;
      margin-bottom: 15%;
      padding-top: 8%;
      .mark-group {
        width: 100%;
        padding: 0 22px;
      }
    }
  }
  .mask {
    background: linear-gradient(180deg, rgba(248, 250, 247, 0.00) 0%, #F8FAF7 80%);
    width: 100%;
    height: 44px;
    position: absolute;
    bottom: 54px;
    left: 0;
    z-index: 1;
  }
  .ellipse {
    max-height: 275px;
    position: absolute;
    bottom: 56px;
    right: 0;
    order: 2;
    width: 90%;
  }
  @media (max-height: 648px) {
    .download{

      .mask,
      .ellipse {
        display: none;
      }
    }
  }
  .copyRight {
    position: absolute;
    left: 0px;
    right: 0;
    bottom: 0px;
    font-size: 12px;
    line-height: 16px;
    color: #888888;
    text-align: center;
    background-color: #f8faf7;
    padding: 20px 0;
    z-index: 3;
  }
}

@media (min-width: 1024px) {
  .download {
    overflow: hidden;

    .copyRight {
      background-color: unset;
    }
    .ellipse,
    .mask,
    .ai-qr {
      display: none;
    }
    .wrap {
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .content{
        .btnDownload {
          & > div {
            padding: 20px 52px;
            flex-direction: row;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            & > .text {
              color: #000;
              font-size: 15px;
              padding-top: 0;
              padding-left: 6px;
            }
          }
        }
        .qrcode{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .qrcode-wrap{
            height: 120px;
            width: 120px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: url('~@/assets/img/qrcode-bg.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100%;
          }
          .tips{
            text-align: center;
            color: #888888;
            font-size: 14px;
          }
        }
        @media screen and (max-width: 414px) {
          .qrcode{
            display: none;
          }
        }
      }
    }
    .qrcode {
      padding-top: 12%;
    }
    .ellipse-right {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(50%, -50%);
      border-radius: 676px;
      opacity: 0.08;
      background: #096ABE;
      filter: blur(100px);
      width: 676px;
      height: 676px;
      flex-shrink: 0;
    }
    .ellipse-left {
      position: absolute;
      left: 0;
      bottom: 0;
      transform: translate(-50%, 50%);
      border-radius: 676px;
      opacity: 0.08;
      background: #096ABE;
      filter: blur(100px);
      width: 676px;
      height: 676px;
      flex-shrink: 0;
    }
  }
}
</style>
